import { Grid2, Typography } from "@mui/material";

const ServiceAddressDetail = ({ formData, fromReview = false }) => {
  return (
    <>
      <Typography variant="h4" color="default.main">
        Service Address
      </Typography>
      {!fromReview && (
        <Typography variant="body1" color="default.light">
          Provide the client’s residential and contact information
        </Typography>
      )}
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 12 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Street Address
          </Typography>
          <Typography variant="body1" color="default.light">
            {`${formData?.serviceAddressSection0?.serviceAddressStreet}${formData?.serviceAddressSection0?.serviceAddress1 ? `, ${formData?.serviceAddressSection0?.serviceAddress1}` : ""}` || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            City
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.serviceAddressCity || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            State
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.serviceAddressState || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            ZIP Code
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.serviceAddressZipCode || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Home Phone
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.homePhone || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Mobile Phone
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.mobilePhone || "-"}
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Preferred Phone
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.preferredPhone || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Email
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceAddressSection0?.email || "-"}
          </Typography>
        </Grid2>
      </Grid2>
    </>
  );
};
export default ServiceAddressDetail;
